interface ClerkDataResource {
  data?: unknown[]
  isLoading?: boolean
}

interface LoadingStateProps {
  memberships: ClerkDataResource | null
  invitations: ClerkDataResource | null
}

interface LoadingStateReturn {
  isMembersLoading: boolean
  isInvitationsLoading: boolean
}

export const useMembersLoadingState = ({
  memberships,
  invitations,
}: LoadingStateProps): LoadingStateReturn => ({
  isMembersLoading: !memberships?.data && memberships?.isLoading !== false,
  isInvitationsLoading: !invitations?.data && invitations?.isLoading !== false,
})
